import { render, staticRenderFns } from "./StatisticPromotionAdditionalDiscount.vue?vue&type=template&id=2cedaff2&"
import script from "./StatisticPromotionAdditionalDiscount.vue?vue&type=script&lang=ts&"
export * from "./StatisticPromotionAdditionalDiscount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports